import { render, staticRenderFns } from "./BankReceiptsAttachmentsDropdown.vue?vue&type=template&id=1d66100d&scoped=true"
import script from "./BankReceiptsAttachmentsDropdown.vue?vue&type=script&lang=js"
export * from "./BankReceiptsAttachmentsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66100d",
  null
  
)

export default component.exports